import Select from "react-select";
import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import { OptionImage } from "../../product/style";

const ModulePropertyDialog = ({
  orderItem,
  tableManager,
  updateModuleProperties,
  toggleClearOverrideModal,
  setClearOverrideFunc,
  clearModuleOverrides,
  mutateCurrentRoom,
  isAdmin,
  properties,
  mode,
  setCurrentTab,
}) => {
  const props = properties.filter(Boolean);
  const propertiesToShow = [
    "minifix",
    "frame_depth",
    "partition_front_edge_thickness",
    "build_type",
    "frame_carcass_type",
    "open_carcass_type",
    "backsheet_build_technique",
    "open_carcass_backsheet_type",
  ];

  const defaultValues = {
    partition_front_edge_thickness: "2",
    frame_depth: "100",
  };

  const getValue = (property) => {
    if (
      !propertiesToShow.includes(property.identifier) ||
      (property.is_automated && property.identifier !== "minifix")
    )
      return "";

    const selected = property.options.find((opt) => opt.selected);

    if (
      !selected ||
      selected.identifier === defaultValues[property.identifier] ||
      (property.level === "project" && !property.is_overridden_v2)
    )
      return "";

    return selected.name;
  };

  const propertyList = isAdmin
    ? props
    : mode === "build"
    ? props.filter(
        (e) =>
          !e.admin_property ||
          (propertiesToShow.includes(e.identifier) && getValue(e))
      )
    : props.filter((e) => !e.admin_property);

  return (
    propertyList.some((e) => e) && (
      <TableViewDialog
        className="end-0"
        end="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex flex-column row-gap-3">
          {propertyList
            .filter((e) => e)
            .map((property, index) => {
              return (
                <div
                  className={`${
                    property.highlight ? "highlight_property" : ""
                  }`}
                >
                  <p className="grey_letter mb-1">{`${property.name} ${
                    !isAdmin && property.admin_property ? "(Admin Control)" : ""
                  }`}</p>
                  <div className="column-gap-3 d-flex align-items-center">
                    {property.is_editable ? (
                      <>
                        <Select
                          autoFocus={index === 0 ? true : false}
                          className="list-summary-select"
                          key={index}
                          isDisabled={!property.is_editable}
                          value={
                            property.options.find(
                              (option) =>
                                option.selected &&
                                (property.is_overridden_v2 ||
                                  property.level === "admin")
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            if (selectedOption.identifier === "__add_more__") {
                              if (setCurrentTab) {
                                const subTab =
                                  property.identifier === "hinge"
                                    ? "hinges"
                                    : "drawers";
                                setCurrentTab("materials", subTab);
                              } else {
                                tableManager.clear();
                              }
                              return;
                            }
                            property.is_overridden_v2 = true;
                            property.options.forEach((o) => {
                              o.selected =
                                o.identifier == selectedOption.identifier;
                            });
                            mutateCurrentRoom();
                            updateModuleProperties({
                              id: orderItem.id,
                              propIdentifier: property.uniq_id,
                              optionIdentifier: selectedOption.identifier,
                            });
                          }}
                          options={[
                            ...property.options.map((option, optionIndex) => {
                              option.value = option.name;
                              option.label = (
                                <div key={optionIndex}>
                                  {option.image && (
                                    <OptionImage
                                      src={option.image}
                                      alt={option.name}
                                      className="border border-dark rounded-circle me-2"
                                    />
                                  )}
                                  {option.name}
                                </div>
                              );
                              option.isDisabled =
                                option.settings_disabled === true ||
                                option.settings_disabled === "true";
                              option.key = index;

                              return {
                                value: option.name,
                                label: option.name,
                                ...option,
                              };
                            }),
                            ...(() => {
                              const hasHinge =
                                property.identifier === "hinge" &&
                                property.is_editable;
                              const hasDrawer =
                                property.identifier ===
                                  "drawer_mechanism_type" &&
                                property.is_editable;
                              if (hasHinge) {
                                return [
                                  {
                                    value: "... add more hinges",
                                    label: "... add more hinges",
                                    identifier: "__add_more__",
                                    key: `add-more-hinge-${index}`,
                                  },
                                ];
                              }
                              if (hasDrawer) {
                                return [
                                  {
                                    value: "... add more drawers",
                                    label: "... add more drawers",
                                    identifier: "__add_more__",
                                    key: `add-more-drawers-${index}`,
                                  },
                                ];
                              }
                              return [];
                            })(),
                          ]}
                        />
                        {property.is_overridden_v2 &&
                          property.is_clearable &&
                          property.is_editable && (
                            <i
                              className="fa-regular fa-trash-can fs-6 pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleClearOverrideModal();
                                setClearOverrideFunc(() => () => {
                                  property.value_name =
                                    property.project_value_name;
                                  property.is_overridden_v2 = false;
                                  clearModuleOverrides({
                                    id: orderItem.id,
                                    propIdentifier: property.uniq_id,
                                  });
                                });
                              }}
                            />
                          )}
                      </>
                    ) : (
                      <div className="mt-1 text-disabled">
                        {!isAdmin && property.admin_property
                          ? getValue(property)
                          : property.options.find((option) => option.selected)
                              ?.name || "No Value"}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
        <TableDialogFooter>
          <TableDialogBtn
            onClick={(e) => {
              e.stopPropagation();
              tableManager.clear();
            }}
            className="mt-3"
          >
            Done
          </TableDialogBtn>
        </TableDialogFooter>
      </TableViewDialog>
    )
  );
};

export default ModulePropertyDialog;
